import { h, VNode } from 'preact';
import { ClubEvent } from '../types';
import {
  formatedEventDay,
  formatedGuestlistAndArrivalTime,
} from '../utils';

interface EventSelectorProps {
  clubEvents: ClubEvent[];
  selectedEvent: ClubEvent | null;
  onChangeEvent: (eventId: number) => void;
  onChangeEventItem: (eventItemId: number) => void;
}

export function EventSelector({
  clubEvents,
  selectedEvent,
  onChangeEvent,
  onChangeEventItem,
}: EventSelectorProps): VNode {
  return (
    <div className="contentContainer">
      <div style={{ width: '100%' }}>
        <div className="label">Select day</div>
        <select
          className="coloredInputLight"
          style={{ width: '100%' }}
          onChange={e =>
            onChangeEvent(
              +(e.target as HTMLOptionElement).value,
            )
          }>
          {clubEvents.length === 0 ? (
            <option value="no-events">No events</option>
          ) : (
            clubEvents.map(item => (
              <option key={item.id} value={item.id}>
                {formatedEventDay({
                  clubTimeZone: item.club.timeZone,
                  eventStartDate: item.startDate,
                })}
              </option>
            ))
          )}
        </select>
      </div>
      <div style={{ width: '100%' }}>
        <div className="label">
          Select guestlist or table
        </div>
        <select
          className="coloredInputLight"
          style={{ width: '100%' }}
          onChange={e =>
            onChangeEventItem(
              +(e.target as HTMLOptionElement).value,
            )
          }>
          {!selectedEvent ||
          selectedEvent?.eventItems.length === 0 ? (
            <option value="no-events">
              No guestlists or tables
            </option>
          ) : (
            selectedEvent?.eventItems.map(item => (
              <option key={item.id} value={item.id}>
                {formatedGuestlistAndArrivalTime({
                  eventName: item.name,
                  arrivalTime: item.arrivalTime,
                  clubTimeZone: selectedEvent.club.timeZone,
                })}
              </option>
            ))
          )}
        </select>
      </div>
    </div>
  );
}
